import React, { useState, useEffect } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import ItemsSection from './components/ItemsSection/ItemsSection';
import CartPage from './components/CartPage/NewCartPage';
import Footer from './components/Footer/Footer';
import { CartProvider } from './contexts/CartContext';
import './styles/global.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      setCurrentPage(hash || 'home');
    };

    // Set initial page based on hash
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'cart':
        return <CartPage />;
      case 'items':
        return <ItemsSection />;
      case 'home':
      default:
        return (
          <>
            <Hero />
            <ItemsSection />
          </>
        );
    }
  };

  return (
    <CartProvider>
      <div className="App">
        <Header />
        <main>
          {renderPage()}
        </main>
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;

